const LoadingOption = () => {
  return <div className="d-block mt-[10px] w-[100%]">Loading....</div>;
};

export default LoadingOption;
